/* eslint-disable no-unused-vars */
import { Interface } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * @class ValidatorInterface
 */
export default new Interface({
    /**
     * @param {AbstractItem} item
     * @return {ValidationResult[]}
     */
    validateItem(item) { return []; },
});
